// extracted by mini-css-extract-plugin
export default {"blogs":"Blogs_blogs__2KGtj","blogs__cont":"Blogs_blogs__cont__ZUNAM","blogs__cont__card":"Blogs_blogs__cont__card__3eZgd"};